import { ContactsProvider } from "./ContactsContext";
import { GarageProvider } from "./GarageContext";
import { RepairOrdersProvider } from "./RepairOrdersContext";
import { AppointmentsProvider } from "./AppointmentsContext";
import { ActivityProvider } from "./ActivityContext";
import { ChatProvider } from "./ChatContext";
import { DealershipTeamProvider } from "./DealershipTeamContext";

export { ChatProvider };

export const UCPContextProviders = ({ children }) => (
  <ContactsProvider>
  <GarageProvider>
    <AppointmentsProvider>
      <RepairOrdersProvider>
        <ActivityProvider>
          <DealershipTeamProvider>
            {children}
          </DealershipTeamProvider>
        </ActivityProvider>
      </RepairOrdersProvider>
    </AppointmentsProvider>
  </GarageProvider>
</ContactsProvider>
);

